'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FocusTrappingInput = require('./FocusTrappingInput');

var _FocusTrappingInput2 = _interopRequireDefault(_FocusTrappingInput);

var _PickerPopover = require('./PickerPopover');

var _PickerPopover2 = _interopRequireDefault(_PickerPopover);

var _dateProptype = require('../date-proptype');

var _dateProptype2 = _interopRequireDefault(_dateProptype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @fileOverview ReactComponent for displaying a date range picker.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author jzetlen
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @memberof component-datepicker
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @function DateRangePicker
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The container component for an entire date range picker, with two
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * {@link FocusTrappingInput} components for start and end date, and a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * {@link PickerPopover} to show a full UI when the inputs are focused.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Displays the `startDate` and `endDate` currently selected in two inputs.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Traps cursor focus in those inputs depending on the value of the `editing`
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * prop. Sets the `showing` prop of the `PickerPopover` depending on whether
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * the `editing` prop is present, thus showing the popover only when editing.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Provides a `getTipTarget` prop to the `PickerPopover` that instructs it to
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * point its visual tip element to the currently editing input.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **/

var DateRangePicker = function (_React$Component) {
	_inherits(DateRangePicker, _React$Component);

	function DateRangePicker(props) {
		_classCallCheck(this, DateRangePicker);

		// we need a ref for the outer element so we can subscribe global
		// click-away events. the below function is passed as a `ref`
		// callback to the outer div. we declare this member in the constructor
		// so that it can assign to `this`, and we don't have to re-bind the
		// function on every render.
		var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));

		_this.assignOuterElement = function (element) {
			_this._outerElement = element;
		};

		// test whether to run the passed `onClickAway` handler
		_this.dispatchClickAway = function (event) {
			if (_this.isOutside(event.target) && _this.props.onClickAway) {
				_this.props.onClickAway(event);
			}
		};

		// test whether to run the passed `onFocusOut` handler
		// make sure active element is outside container and isn't `Body`
		_this.dispatchFocusOut = function (event) {
			if (_this.props.onFocusOut) {
				setTimeout(function () {
					var activeElement = document.activeElement;
					if (activeElement.nodeName !== 'BODY' && _this.isOutside(activeElement)) {
						_this.props.onFocusOut(event);
					}
				}, 0);
			}
		};

		// we need access to the inputs so we can use their `.getInput`
		// methods to get their DOM elements, so we can create the
		// `getTipTarget` method that `PickerPopover` uses to position the
		// popover tip.
		var inputs = {};
		// as before, this will be passed as a ref callback.
		_this.assignInput = function (component) {
			// should never happen, but check that the input has `behavior`
			if (component && component.props && component.props.behavior) {
				// store inputs.start and inputs.end as they are rendered
				inputs[component.props.behavior] = component;
			}
		};
		// so that the tip does not flicker as editing state disappears,
		// store the most recent tip target in this closure.
		var tipTarget = void 0;
		_this.getTipTarget = function () {
			// if editing === 'start', pass inputs.start, etc.
			tipTarget = inputs[_this.props.editing] || tipTarget;
			// run the FocusTrappingInput's `getInput` method to retrieve the
			// actual DOM element.
			return tipTarget && tipTarget.getInput();
		};
		return _this;
	}

	_createClass(DateRangePicker, [{
		key: 'isOutside',
		value: function isOutside(target) {
			return !this._outerElement.contains(target);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			document.body.addEventListener('click', this.dispatchClickAway);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			document.body.removeEventListener('click', this.dispatchClickAway);
		}
	}, {
		key: 'render',
		value: function render() {
			var props = this.props;
			// using inline style since these properties are absolutely necessary
			// for the component to function
			var outerStyle = {
				position: 'relative',
				overflow: 'visible'
			};
			return _react2.default.createElement(
				'div',
				{
					ref: this.assignOuterElement,
					style: outerStyle,
					className: props.className,
					onBlurCapture: this.dispatchFocusOut },
				_react2.default.createElement(_FocusTrappingInput2.default, {
					ref: this.assignInput,
					className: props.inputClassName,
					behavior: 'start',
					trapFocus: props.editing === 'start',
					nameSpace: props.nameSpace,
					label: props.labels.startDate,
					placeholder: props.labels.datePatternPlaceholder,
					value: props.formatDate(props.startDate),
					date: props.startDate,
					onFocus: props.onFocusInput,
					onKeyDown: props.onInputKeyDown,
					onChange: props.onInputChange,
					ariaLabel: props.labels.startDateA11yText
				}),
				_react2.default.createElement(_FocusTrappingInput2.default, {
					ref: this.assignInput,
					className: props.inputClassName,
					behavior: 'end',
					trapFocus: props.editing === 'end',
					nameSpace: props.nameSpace,
					label: props.labels.endDate,
					placeholder: props.labels.datePatternPlaceholder,
					value: props.formatDate(props.endDate),
					date: props.endDate,
					onFocus: props.onFocusInput,
					onKeyDown: props.onInputKeyDown,
					onChange: props.onInputChange,
					ariaLabel: props.labels.endDateA11yText
				}),
				_react2.default.createElement(_PickerPopover2.default, _extends({
					showing: !!props.editing,
					getTipTarget: this.getTipTarget,
					onShow: props.onPopoverShow,
					onHide: props.onPopoverHide,
					ariaLabel: props.labels.closeButtonA11yText
				}, props))
			);
		}
	}]);

	return DateRangePicker;
}(_react2.default.Component);

var string = _react.PropTypes.string,
    oneOf = _react.PropTypes.oneOf,
    func = _react.PropTypes.func,
    shape = _react.PropTypes.shape;

DateRangePicker.propTypes = {
	startDate: _dateProptype2.default.isRequired,
	endDate: _dateProptype2.default.isRequired,
	showMonth: _dateProptype2.default.isRequired,
	editing: oneOf(['start', 'end', false]),
	formatDate: func.isRequired,
	onFocusInput: func,
	onInputKeyDown: func,
	onInputChange: func,
	onPopoverShow: func,
	onPopoverHide: func,
	labels: shape({
		startDate: string.isRequired,
		endDate: string.isRequired,
		datePatternPlaceholder: string.isRequired,
		startDateA11yText: string,
		endDateA11yText: string,
		closeButtonA11yText: string
	}),
	className: string,
	inputClassName: string,
	nameSpace: string
};

DateRangePicker.defaultProps = {
	nameSpace: 'dateinput'
};

exports.default = DateRangePicker;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/component-datepicker/dist/components/DateRangePicker.js
// module id = 504
// module chunks = 0